module.exports = __webpack_public_path__ + "static/media/Lashes01.11d05d62.jpeg";